<ng-container *t="let t">
    <div class="right-container">
        <button
            tsl-button
            color="black"
            size="small"
            outline
            (click)="onAdd()"
            i18n="@@04a4d53ee28994e1b23509bd2c30c4538c256951"
            t="04a4d53ee28994e1b23509bd2c30c4538c256951"
            >Add Product Experiance
        </button>
    </div>
    <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
        <ng-container tslColumnDef="commodity">
            <th
                tsl-sort-header
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@9fe054392fc13b9f33fa2f9552dc87f0801b27d7"
                t="9fe054392fc13b9f33fa2f9552dc87f0801b27d7"
            >
                Commodity
            </th>
            <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.commodityDescription) }} </td>
        </ng-container>

        <ng-container tslColumnDef="years">
            <th
                tsl-sort-header
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@8a6b2c0c889f2b2b7b867e42bf76b63b7287f2e7"
                t="8a6b2c0c889f2b2b7b867e42bf76b63b7287f2e7"
            >
                Years
            </th>
            <td tsl-cell *tslCellDef="let item"> {{ item.experienceYears }} </td>
        </ng-container>

        <ng-container tslColumnDef="volume">
            <th
                tsl-sort-header
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@21c7cbaff37471ead857f208b2eb92ffb4d08c5d"
                t="21c7cbaff37471ead857f208b2eb92ffb4d08c5d"
            >
                Volume
            </th>
            <td tsl-cell *tslCellDef="let item"> {{ item.volume }} </td>
        </ng-container>

        <ng-container tslColumnDef="doesProduction">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@8ffa1da481f7d15daedf7b5b1ba88fd21eed32bc"
                t="8ffa1da481f7d15daedf7b5b1ba88fd21eed32bc"
            >
                Does Production
            </th>
            <td tsl-cell *tslCellDef="let item">
                <tsl-icon status="primary" *ngIf="item.doesProduction !== undefined && item.doesProduction"
                    >thumb_up
                </tsl-icon>
                <tsl-icon status="error" *ngIf="item.doesProduction !== undefined && !item.doesProduction"
                    >thumb_down
                </tsl-icon>
            </td>
        </ng-container>

        <ng-container tslColumnDef="doesPrototype">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@a17d7444bf883ae2783c9389f900c663691baf17"
                t="a17d7444bf883ae2783c9389f900c663691baf17"
            >
                Does Prototype
            </th>
            <td tsl-cell *tslCellDef="let item">
                <tsl-icon status="primary" *ngIf="item.doesPrototype !== undefined && item.doesPrototype"
                    >thumb_up
                </tsl-icon>
                <tsl-icon status="error" *ngIf="item.doesPrototype !== undefined && !item.doesPrototype"
                    >thumb_down
                </tsl-icon>
            </td>
        </ng-container>

        <ng-container tslColumnDef="action">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action"> Action </th>
            <td tsl-cell *tslCellDef="let item">
                <button tsl-icon-button tooltip="Edit" i18n-tooltip="@@Edit" #editButton tslTooltip="{{ t('Edit', editButton) }}" (click)="onEdit(item)">
                    <tsl-icon>edit</tsl-icon>
                </button>
                <button tsl-icon-button tooltip="Delete" i18n-tooltip="@@Delete" #deleteButton tslTooltip="{{ t('Delete', deleteButton) }}" (click)="onRemove(item)">
                    <tsl-icon status="error">delete</tsl-icon>
                </button>
            </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <tsl-pagination
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        showFirstLastButtons
        (pageChange)="onPageChange($event)"
        [total]="productResult.length"
        [itemsPerPageLabel]="translate.get('ItemsPerPage')"
    ></tsl-pagination>
</ng-container>
